import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetMyTestByIdQuery } from "../context/apiSlice";
import GeneratedTestView from "./GeneratedTestView";

export default function TestDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, isError } = useGetMyTestByIdQuery(id, {
    skip: !id,
  });

  if (isLoading) {
    return <div className="p-10">Yuklanmoqda...</div>;
  }

  if (isError || !data?.test) {
    return <div className="p-10 text-red-500">Test topilmadi</div>;
  }

  const t = data.test;

  const viewTest = {
    id: t.id,
    title: t.title || "Test",
    totalQuestions: t.questions?.length || 0,
    questions: t.questions.map((q, i) => ({
      id: i,
      text: q.question || q.text,
      options: q.options,
      correctIndex: q.answerIndex ?? q.correctIndex ?? 0,
    })),
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-5xl mx-auto px-4">
        <button
          onClick={() => navigate("/dashboard/tests")}
          className="text-sm mb-4 underline"
        >
          ← Orqaga
        </button>

        <GeneratedTestView test={viewTest} />
      </div>
    </div>
  );
}
